import React, { useEffect, useState } from "react";
import { 
	message,
	List,
	Button,
	Drawer,
	Space,
	Popconfirm,
	Transfer,
	Descriptions,
	Input,
	InputNumber,
	Badge,
	Row,
	Col,
	theme
} from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { get_databases, edit_database, get_companies } from "../services";
import TextArea from "antd/es/input/TextArea";
import { InformationComponent } from "../components/InformationComponent";
import { useCalculateListSizeForPaginationHook } from "../hooks";
import { reduceText } from "../utils/Formaters";

import PropTypes from "prop-types";
import { CircleAnimationCompact } from "../components/loading";
import { hover_item } from "../hover";

const empty_database = {
	description: "",
	assigned_companies: [],
	version: null, 
	id:"", 
	system: "", 
	name: "",
	active: true,
	url: ""
};

export const DataBases = ({token}) => {
	const { token: antToken } = theme.useToken();

	const [databases, setDatabases] = useState([]);
	const [dbCompanies, setDbCompanies] = useState([]);
	const [selected, setSelected] = useState(empty_database);
	const [selectedKeys, setSelectedKeys] = useState([]);
	const [loading, setLoading] = useState(true);
	const [loadingSubmit, setLoadingSubmit] = useState(false);
	const { pageSize } = useCalculateListSizeForPaginationHook(70);
	const [openCreate, setOpenCreate] = useState(false);
	const [openEdit, setOpenEdit] = useState(false);
	const [hoveredItem, setHoveredItem] = useState(null);

	const check_companies_to_assign = (item_selected = null) => {
		const formated_companies = dbCompanies.map((company) => {			
			const isDisabled = (item_selected === null) ? databases.some((item) => 
				item.assigned_companies.includes(company.nit)
			) : databases.some((item) => 
				item_selected.id !== item.id && item.assigned_companies.includes(company.nit)
			);

			return {
				...company,
				disabled: isDisabled,
			};
		});
		setDbCompanies(formated_companies);
	};

	const reset_companies_to_assign = () => {
		const formated_companies = dbCompanies.map((company) => {
			return {
				...company,
				disabled: false,
			};
		});
		setDbCompanies(formated_companies);
	};
	
	const showCreate = () => {
		setOpenCreate(true);
		check_companies_to_assign();
	};
	
	const showEdit = (item) => {
		setOpenEdit(true);
		check_companies_to_assign(item);
	};

	const onClose = () => {
		setOpenEdit(false);
		setOpenCreate(false);
		reset_companies_to_assign();
		setSelected(empty_database);
	};

	const handleChageDB = (value, attribute) => {
		setSelected((dbSelected) => ({
			...dbSelected, [attribute] : value
		}));
	};

	const handleChange = (newTargetKeys) => {
		handleChageDB(newTargetKeys, "assigned_companies");
	};
	
	const handleSelectChange = (sourceSelectedKeys, targetSelectedKeys) => {
		setSelectedKeys([...sourceSelectedKeys, ...targetSelectedKeys]);
	};
	
	const submitChanges = async (edit_value) => {
		if(edit_value === "create"){
			if(
				selected.name === "" || 
				selected.system === "" || 
				selected.version === null || 
				selected.description === "" || 
				selected.url === ""
			){
				message.warning("Porfavor llene los campos pendientes para crear la nueva base de datos");
				return;
			}

			if(selected.version <= 0){
				message.warning("Número de versión invalido");
				return;
			}
		}

		setLoadingSubmit(true);		

		const data_content = (value) => {
			if(value === "create"){
				return {
					name: selected.name,
					system: selected.system.toLowerCase(),
					version: `${selected.version}`,
					description: selected.description,
					url: selected.url,
					assigned_companies: selected.assigned_companies,
				};
			}
			if(value === "edit"){
				return {
					id: selected.id,
					assigned_companies: selected.assigned_companies
				};					
			}
			if(value === "deactivate"){
				return {id: selected.id};
			}
			return null;
		};
		
		try {			
			const res = await edit_database(token, edit_value, data_content(edit_value));

			if(res){
				message.success(res);

				setDatabases(databases.map(db => {
					if(db.id === selected.id){
						if(edit_value === "deactivate"){
							return {...selected, active:false, assigned_companies:[]};
						}
						
						return selected;
					}
					return db;
				}));			
	
				onClose();
			}
		} catch(error){
			console.error(error);
			message.error(error.message);
			onClose();
		}

		setLoadingSubmit(false);
	};
	
	useEffect(() => {
		const fetchData = async () => {
			try{
				const res = await get_databases(token);

				if(!res){
					setLoading(false);
					return;
				}

				setDatabases(res);

				const res_companies = await get_companies(token, "is_associated");
				if(res_companies){
					
					const formated_companies = res_companies.map((company) => {
						return {
							nit: company.id,
							name: company.name,
							key: company.id,
							disabled: false
						};
					});
					setDbCompanies(formated_companies);
				}

				setLoading(false);
			} catch(error){
				console.error(error.response.data);
				message.error(error.response.data);
			}
		};

		fetchData();
	}, []);

	const TransferCompaniesComponent = () => {
		return (
			<div>
				<h3>Compañias Asignadas:</h3>
				<Transfer
					dataSource={dbCompanies}
					disabled={!selected.active}
					loading={loading}
					listStyle={{
						width: 350,
						height: 300,
					}}
					showSearch
					filterOption={(inputValue, item) =>
						item.name.toLowerCase().includes(inputValue.toLowerCase())
					}
					titles={["Compañias Disponibles", "Compañias Asignados"]}
					targetKeys={selected.assigned_companies}
					selectedKeys={selectedKeys}
					onChange={handleChange}
					onSelectChange={handleSelectChange}
					render={(item) => item.name}
					style={{
						marginBottom: 16,
						marginTop:"10px"
					}}
				/>
			</div>
		);
	};

	const UrlComponent = () => {
		return (
			<div>
				<h3>URL: </h3>
				<a 
					href={selected.url}
					target="_blank"
					rel="noopener noreferrer"
				>
					<p className="urlText">{selected.url}</p>
				</a>
			</div>
		);
	};

	return (
		<>
			{
				loading &&
				<CircleAnimationCompact/>
			}
			{
				!loading &&
				<>
					<Button
						type="primary"
						onClick={showCreate}
					>
						Agregar Nueva Base de Datos
					</Button>
					<List
						pagination={{
							position:"top",
							align:"center",
							pageSize: pageSize,
							showSizeChanger: false,
							disabled: false,
						}}
						dataSource={databases}
						header={
							<Row
								style={{
									background: antToken.colorBgLayout,
									borderRadius: "10px"
								}}
							>
								<Col flex="auto">
									<List.Item key={0} >
										<List.Item.Meta  
											style={{
												fontWeight: 600, // reduce grosor de la letra
											}} 
											title="Nombre" 
											description="Descripción" 
										/>
										<List.Item.Meta 
											style={{
												fontWeight: 600, // reduce grosor de la letra
											}} 
											title="Estado" 
											description="Sistema" 
										/>
									</List.Item>
								</Col>
							</Row>
						}
						renderItem={(item, index) => (
							<>
								<List.Item
									key={index}
									onMouseEnter={() => setHoveredItem(index)}
									onMouseLeave={() => setHoveredItem(null)}
									onClick={() => {
										setSelected(item);
										showEdit(item);
									}}
									style={hover_item(hoveredItem === index, antToken, "invoices", 70)}
								>
									<List.Item.Meta
										title={reduceText(item.name)}
										description={reduceText(item.description)}
									/>
									<List.Item.Meta
										title={<Badge status={item?.active? "success" : "default"} text={item.active?  "Activo" : "Inactivo"} />}
										description={reduceText(`${item.system}, ${item.version}`)}
									/>
								</List.Item>
							</>
						)}
					></List>
				</>
			}
			<Drawer
				title="Agregar una Base de Datos"
				placement="right"
				width={800}
				onClose={onClose}
				open={openCreate}
				extra={
					<Space>
						<Button type="primary" loading={loadingSubmit} onClick={() => {submitChanges("create");}}>
							Crear
						</Button>
					</Space>
				}
			>
				<Descriptions
					layout="vertical"
					labelStyle={{
						color: "black",
						fontWeight: "bold",
					}}
				>					
					<Descriptions.Item label={"Nombre"}>
						<Input
							rows={1}
							showCount
							status={(selected.name.trim() === "") ? "error" : ""}
							value={selected.name}
							onChange={(event) => handleChageDB(event.target.value, "name")}
						/>
					</Descriptions.Item>					
					<Descriptions.Item label={"Sistema"}>
						<Input
							rows={1}
							showCount
							status={(selected.system.trim() === "") ? "error" : ""}
							value={selected.system}
							onChange={(event) => handleChageDB(event.target.value, "system")}
							maxLength={15}
						/>
					</Descriptions.Item>
					<Descriptions.Item label={"Versión"}>
						<InputNumber
							rows={1}
							status={(selected.version === null || (selected.version !== null && selected.version <= 0)) ? "error" : ""}
							value={selected.version}
							onChange={(value) => handleChageDB(value, "version")}
						/>
					</Descriptions.Item>					
					<Descriptions.Item label={"Descripción"}>
						<TextArea
							rows={1}
							showCount
							status={(selected.description.trim() === "") ? "error" : ""}
							value={selected.description}
							onChange={(event) => handleChageDB(event.target.value, "description")}
							maxLength={30}
						/>
					</Descriptions.Item>
					<Descriptions.Item label={"URL"}>
						<TextArea
							rows={1}
							showCount
							status={(selected.url.trim() === "") ? "error" : ""}
							value={selected.url}
							onChange={(event) => handleChageDB(event.target.value, "url")}
						/>
					</Descriptions.Item>
				</Descriptions>
				<TransferCompaniesComponent/>
			</Drawer>

			<Drawer
				title="Editar Base de Datos"
				placement="right"
				width={800}
				onClose={onClose}
				open={openEdit}
				extra={
					<Space>
						<Popconfirm
							title="Desactivar Base de Datos"
							description="Estas seguro que quieres desactivar esta base de datos?"
							onConfirm={() => {submitChanges("deactivate");}}
							icon={<QuestionCircleOutlined style={{ color: "red" }} />}
						>
							<Button type="primary" disabled={!selected.active} loading={loadingSubmit} danger>
								Desactivar
							</Button>
						</Popconfirm>
						<Button type="primary" disabled={!selected.active} loading={loadingSubmit} onClick={() => {submitChanges("edit");}}>
							Editar
						</Button>
					</Space>
				}
			>				
				<InformationComponent title={"Nombre: "} attribute={selected.name} />
				<InformationComponent title={"Sistema: "} attribute={selected.system} />
				<InformationComponent title={"Versión: "} attribute={selected.version} />
				<InformationComponent title={"Descripción: "} attribute={selected.description} />				
				<UrlComponent/>
				<TransferCompaniesComponent/>
			</Drawer>
		</>
	);
};

DataBases.propTypes = {
	token: PropTypes.string.isRequired,		
};
